const destinationVariants = Object.freeze({
  'treggo-ugostiteljski-frizider-54-x-53-x-165-cm-2-do-8-c': '56889741377868',
  'treggo-xxl-premium-maxi-frizider-195-crni': '59274347413836',
  'treggo-ugostiteljski-frizider-60x60x180-cm-cash-carry': '57946544537932',
  'treggo-ugostiteljski-frizider-49-x-49-x-110-2-do-8-c': '58448208101708',
  'treggo-dvokrilni-ugostiteljski-frizider-120-x-57-x-170-cm-2-do-8-c': '56780762186060',
  'treggo-sank-inox': '59082211656012',
  'treggo-ugostiteljski-frizider-treggofrisv1': '56640773423436',
  'treggo-ugostiteljski-frizider-55-x-64-x-195-cm-2-do-8-c': '56738069610828',
  'treggo-ugostiteljski-frizider-62-x-55-x-175-cm-2-do-8-c': '57106742673740',
  'treggo-ugostiteljski-frizider-63l': '58013086187852',
  'treggo-ugostiteljski-frizider-60x64x178-cm': '58181144445260',
  'treggo-1-1-dva-ugostiteljska-frizider-55-x-64-x-175-cm-2-do-8-c': '56778493296972'
});

export async function treggoCheckoutURL(items, getProduct) {
  if (!Array.isArray(items) || !items.length) throw new Error('empty');
  const requests = new Map();
  for (const item of items) {
    if (!Object.hasOwn(destinationVariants, item.handle)) throw new Error('unmapped');
    if (!Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('quantity');
  }
  const lines = await Promise.all(items.map(async item => {
    if (!requests.has(item.handle)) requests.set(item.handle, getProduct(item.handle));
    const product = await requests.get(item.handle);
    const variant = product.variants?.find(v => String(v.id) === destinationVariants[item.handle]);
    if (product.handle !== item.handle || !variant || !Array.isArray(item.options) ||
        JSON.stringify(variant.options) !== JSON.stringify(item.options)) throw new Error('unmapped');
    if (!variant.available) throw new Error('unavailable');
    return {id: String(variant.id), quantity: item.quantity};
  }));
  const totals = new Map();
  for (const line of lines) {
    const quantity = (totals.get(line.id) || 0) + line.quantity;
    if (!Number.isSafeInteger(quantity)) throw new Error('quantity');
    totals.set(line.id, quantity);
  }
  const url = new URL('https://mytreggo.com/cart/' + [...totals].map(([id, quantity]) => `${id}:${quantity}`).join(','));
  url.searchParams.set('locale', 'hr');
  url.searchParams.set('attributes[Izvor]', 'frizideri.hr');
  url.searchParams.set('ref', 'frizideri-hr');
  return url.href;
}

if (typeof document !== 'undefined') {
  const config = JSON.parse(document.getElementById('themeConfig')?.textContent || '{}');
  const messages = config.treggo || {};
  let busy = false;
  let restore = () => {};

  async function getJSON(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {...options, signal: controller.signal});
      if (!response.ok) throw new Error('error');
      return await response.json();
    } finally {
      clearTimeout(timer);
    }
  }

  async function cartItems(form) {
    const inputs = [...(form?.querySelectorAll('[data-treggo-line-key]') || [])];
    const updates = {};
    for (const input of inputs) {
      const quantity = Number(input.value);
      if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('quantity');
      updates[input.dataset.treggoLineKey] = quantity;
    }
    const cart = inputs.length
      ? await getJSON(config.cartUpdate + '.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({updates})})
      : await getJSON(config.cart + '.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}});
    return cart.items.map(item => ({handle: item.handle, options: item.variant_options, quantity: item.quantity}));
  }

  function productItems(form) {
    const product = JSON.parse(form.querySelector('[data-treggo-product]').textContent);
    const data = new FormData(form);
    const variant = product.variants.find(v => String(v.id) === String(data.get('id')));
    if (!variant) throw new Error('unmapped');
    return [{handle: product.handle, options: variant.options, quantity: Number(data.get('quantity') || 1)}];
  }

  async function checkout(button, form, buyNow = false) {
    if (busy || (form && !form.reportValidity())) return;
    busy = true;
    const oldHTML = button?.innerHTML;
    const wasDisabled = button?.disabled;
    const error = form?.querySelector('[data-form-error]') || document.getElementById('themeToast');
    if (error) error.hidden = true;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = messages.wait;
    }
    restore = () => {
      busy = false;
      if (button) {
        button.disabled = wasDisabled;
        button.removeAttribute('aria-busy');
        button.innerHTML = oldHTML;
      }
    };
    try {
      const items = buyNow ? productItems(form) : await cartItems(form);
      const url = await treggoCheckoutURL(items, handle => getJSON('https://mytreggo.com/products/' + encodeURIComponent(handle) + '.js', {credentials: 'omit', headers: {Accept: 'application/json'}}));
      window.location.assign(url);
    } catch (failure) {
      if (error) {
        error.textContent = messages[failure.message] || messages.error;
        error.hidden = false;
      }
      restore();
    }
  }

  function localCheckoutURL(value) {
    try {
      const url = new URL(value, window.location.href);
      return url.origin === window.location.origin && /\/(checkout|checkouts)(\/|$)/.test(url.pathname);
    } catch {
      return false;
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-native-buy], [data-treggo-cart-checkout], button[name="checkout"], input[name="checkout"]');
    const link = event.target.closest('a[href]');
    if (!button && !(link && localCheckoutURL(link.href))) return;
    event.preventDefault();
    const control = button || link;
    const form = control.form || document.getElementById('cart-form');
    checkout(control, form, control.hasAttribute('data-native-buy'));
  }, true);

  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout' && !localCheckoutURL(event.target.action)) return;
    event.preventDefault();
    checkout(event.submitter, event.target);
  }, true);

  window.addEventListener('pageshow', () => restore());
}
